import '/app/brewery-packages/content/content-editor-plugin-unordered-list/src/UnorderedList.css-raw';
export default {
  "unorderedList": "employees-21b62107-unorderedList-wCRGkq"
};